import React from "react";
import { ChevronRight } from "lucide-react";
import { LogoutOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";

const AdminHeader = ({ title }) => {
  const navigate = useNavigate();
  const userMenu = {
    items: [
      {
        key: "logout",
        icon: <LogoutOutlined />,
        label: "Sign Out",
        danger: true,
      },
    ],
    onClick: ({ key }) => {
      console.log("Menu clicked:", key);

      if (key === "logout") {
        console.log("Before:", localStorage.getItem("rwatoken"));

        localStorage.removeItem("rwatoken");
        localStorage.removeItem("userRole");

        console.log("After:", localStorage.getItem("rwatoken"));
        window.location.href = "/";
        navigate("/login", { replace: true });
      }
    },
  };
  return (
    <header className="sticky top-0 z-30 flex h-[45px] items-center justify-between border-b border-[#dfe3e8] bg-white px-5">
      <div className="flex items-center gap-2">
        <span className="text-[9px] text-[#82909c]">PropVault Admin</span>

        <ChevronRight size={10} className="text-[#a8b0b7]" />

        <span className="text-[9px] font-semibold text-[#182b39]">{title}</span>
      </div>

      <div className="flex items-center gap-2">
        <div className="rounded-full bg-[#f5f6f8] px-2.5 py-1 text-[11px] text-[#71808c]">
          16 Sep 2026
        </div>

        <Dropdown menu={userMenu} trigger={["click"]} placement="bottomRight">
          <button
            type="button"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-[#e9dfca] text-[11px] font-bold text-[#20485b] cursor-pointer"
          >
            AS
          </button>
        </Dropdown>
      </div>
    </header>
  );
};

export default AdminHeader;
